import { render, staticRenderFns } from "./BwLeafFormatter.vue?vue&type=template&id=cb35a8ac&functional=true"
import script from "./BwLeafFormatter.vue?vue&type=script&lang=js"
export * from "./BwLeafFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports